/**
 * Parses vehicle number to one format
 * @param vehicleRegNumber
 * @returns uniform vehicleRegNumber
 */
export default function parseVehicleRegNumber(vrn: string): string {
  return vrn.replace(/[\s-]/g, "").toUpperCase();
}
